export default __webpack_public_path__ + "static/media/user-bg.2b2e8d3f.svg";